var _rect, _rect2, _rect3, _rect4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect5, _rect6, _circle, _path10, _path11, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path12, _path13, _g10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 320,
    viewBox: "0 0 284 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 130,
    width: 172,
    height: 60,
    rx: 12,
    fill: "#3F3F46",
    fillOpacity: 0.56
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 132,
    width: 168,
    height: 56,
    rx: 11,
    fill: "#18181B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 188,
    width: 20,
    height: 2,
    fill: "url(#paint0_linear_3105_3807)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 87,
    width: 20,
    height: 2,
    fill: "url(#paint1_linear_3105_3807)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3105_3807)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 152,
    width: 19.4286,
    height: 32,
    rx: 4,
    fill: "url(#paint2_linear_3105_3807)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3105_3807)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.4287,
    y: 140,
    width: 19.4286,
    height: 44,
    rx: 4,
    fill: "url(#paint3_linear_3105_3807)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_3105_3807)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.857,
    y: 121,
    width: 19.4286,
    height: 63,
    rx: 4,
    fill: "url(#paint4_linear_3105_3807)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_3105_3807)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.286,
    y: 95,
    width: 19.4286,
    height: 89,
    rx: 4,
    fill: "url(#paint5_linear_3105_3807)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_3105_3807)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.714,
    y: 140,
    width: 19.4286,
    height: 44,
    rx: 4,
    fill: "url(#paint6_linear_3105_3807)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_3105_3807)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.143,
    y: 152,
    width: 19.4286,
    height: 32,
    rx: 4,
    fill: "url(#paint7_linear_3105_3807)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_3105_3807)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 202.571,
    y: 152,
    width: 19.4286,
    height: 32,
    rx: 4,
    fill: "url(#paint8_linear_3105_3807)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264 0H20V66C20 68.2091 21.7909 70 24 70H39.6787C41.1141 70 42.4395 69.2309 43.1517 67.9846L52.8483 51.0154C53.5605 49.7691 54.8859 49 56.3213 49H227.63C229.091 49 230.436 49.797 231.138 51.0787L240.362 67.9213C241.064 69.203 242.409 70 243.87 70H260C262.209 70 264 68.2091 264 66V0Z",
    fill: "url(#paint9_linear_3105_3807)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 66V0.5H263.5V66C263.5 67.933 261.933 69.5 260 69.5H243.87C242.591 69.5 241.414 68.8027 240.8 67.6811L231.577 50.8386C230.787 49.3966 229.274 48.5 227.63 48.5H56.3213C54.7064 48.5 53.2154 49.3653 52.4142 50.7674L42.7176 67.7365C42.0944 68.827 40.9347 69.5 39.6787 69.5H24C22.067 69.5 20.5 67.933 20.5 66Z",
    stroke: "url(#paint10_linear_3105_3807)",
    strokeOpacity: 0.04
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264 320H20V254C20 251.791 21.7909 250 24 250H39.6787C41.1141 250 42.4395 250.769 43.1517 252.015L52.8483 268.985C53.5605 270.231 54.8859 271 56.3213 271H227.63C229.091 271 230.436 270.203 231.138 268.921L240.362 252.079C241.064 250.797 242.409 250 243.87 250H260C262.209 250 264 251.791 264 254V320Z",
    fill: "url(#paint11_linear_3105_3807)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 254V319.5H263.5V254C263.5 252.067 261.933 250.5 260 250.5H243.87C242.591 250.5 241.414 251.197 240.8 252.319L231.577 269.161C230.787 270.603 229.274 271.5 227.63 271.5H56.3213C54.7064 271.5 53.2154 270.635 52.4142 269.233L42.7176 252.264C42.0944 251.173 40.9347 250.5 39.6787 250.5H24C22.067 250.5 20.5 252.067 20.5 254Z",
    stroke: "url(#paint12_linear_3105_3807)",
    strokeOpacity: 0.04
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132 130V49",
    stroke: "url(#paint13_linear_3105_3807)",
    strokeOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152 130V49",
    stroke: "url(#paint14_linear_3105_3807)",
    strokeOpacity: 0.08
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132 190V271",
    stroke: "url(#paint15_linear_3105_3807)",
    strokeOpacity: 0.08
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152 190V271",
    stroke: "url(#paint16_linear_3105_3807)",
    strokeOpacity: 0.08
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M264 320V0",
    stroke: "url(#paint17_linear_3105_3807)",
    strokeOpacity: 0.08
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M283 208L283 112",
    stroke: "url(#paint18_linear_3105_3807)",
    strokeOpacity: 0.08
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 208L1 112",
    stroke: "url(#paint19_linear_3105_3807)",
    strokeOpacity: 0.08
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 320V0",
    stroke: "url(#paint20_linear_3105_3807)",
    strokeOpacity: 0.08
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20 95L264 95",
    stroke: "url(#paint21_linear_3105_3807)",
    strokeOpacity: 0.08,
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 94,
    width: 11,
    height: 2,
    fill: "url(#paint22_linear_3105_3807)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 2,
    transform: "matrix(-1 0 0 1 31 94)",
    fill: "url(#paint23_linear_3105_3807)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 95,
    r: 3,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 83.0667C19.6 82.5333 20.4 82.5333 20.8 83.0667L24.8 88.4C25.2944 89.0592 24.824 90 24 90H16C15.176 90 14.7056 89.0592 15.2 88.4L19.2 83.0667Z",
    fill: "#A0A0AB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 106.933C19.6 107.467 20.4 107.467 20.8 106.933L24.8 101.6C25.2944 100.941 24.824 100 24 100H16C15.176 100 14.7056 100.941 15.2 101.6L19.2 106.933Z",
    fill: "#A0A0AB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 70,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#333438"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 114.25,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#333438"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 136.375,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#333438"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 158.5,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#333438"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 180.625,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#333438"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 202.75,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#333438"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 224.875,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#333438"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 247,
    width: 6,
    height: 3,
    rx: 1.5,
    fill: "#333438"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M142 49V39",
    stroke: "url(#paint24_linear_3105_3807)",
    strokeOpacity: 0.08
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M142 271V281",
    stroke: "url(#paint25_linear_3105_3807)",
    strokeOpacity: 0.08
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_3105_3807)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 207,
    width: 82,
    height: 34,
    rx: 17,
    stroke: "url(#paint26_linear_3105_3807)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_3105_3807)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 210,
    width: 76,
    height: 28,
    rx: 14,
    fill: "url(#paint27_linear_3105_3807)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.992 227.29V220.568H117.33V227.29H115.992ZM113.303 224.595V223.263H120.024V224.595H113.303ZM125.712 229.139C125.029 229.139 124.419 229.022 123.882 228.786C123.348 228.551 122.926 228.224 122.614 227.807C122.306 227.386 122.14 226.899 122.117 226.345H123.678C123.698 226.647 123.799 226.909 123.982 227.131C124.167 227.349 124.409 227.518 124.707 227.638C125.006 227.757 125.337 227.817 125.702 227.817C126.103 227.817 126.457 227.747 126.766 227.608C127.077 227.469 127.321 227.275 127.496 227.026C127.672 226.774 127.76 226.484 127.76 226.156C127.76 225.815 127.672 225.515 127.496 225.256C127.324 224.995 127.071 224.789 126.736 224.64C126.404 224.491 126.003 224.416 125.533 224.416H124.673V223.163H125.533C125.911 223.163 126.242 223.095 126.527 222.96C126.815 222.824 127.041 222.635 127.203 222.393C127.366 222.147 127.447 221.861 127.447 221.533C127.447 221.218 127.375 220.944 127.233 220.712C127.094 220.477 126.895 220.293 126.636 220.161C126.381 220.028 126.08 219.962 125.732 219.962C125.4 219.962 125.09 220.023 124.802 220.146C124.517 220.265 124.285 220.437 124.106 220.663C123.927 220.885 123.831 221.152 123.817 221.463H122.331C122.348 220.913 122.51 220.429 122.818 220.011C123.13 219.594 123.541 219.267 124.051 219.032C124.562 218.797 125.128 218.679 125.751 218.679C126.404 218.679 126.968 218.807 127.442 219.062C127.919 219.314 128.287 219.65 128.545 220.071C128.807 220.492 128.937 220.953 128.933 221.453C128.937 222.023 128.777 222.507 128.456 222.905C128.138 223.303 127.714 223.569 127.183 223.705V223.785C127.859 223.888 128.383 224.156 128.754 224.59C129.129 225.024 129.314 225.563 129.311 226.206C129.314 226.766 129.159 227.268 128.844 227.712C128.532 228.156 128.106 228.506 127.566 228.761C127.026 229.013 126.408 229.139 125.712 229.139ZM134.735 229.139C134.052 229.139 133.442 229.022 132.906 228.786C132.372 228.551 131.949 228.224 131.638 227.807C131.33 227.386 131.164 226.899 131.141 226.345H132.702C132.722 226.647 132.823 226.909 133.005 227.131C133.191 227.349 133.433 227.518 133.731 227.638C134.029 227.757 134.361 227.817 134.725 227.817C135.126 227.817 135.481 227.747 135.789 227.608C136.101 227.469 136.344 227.275 136.52 227.026C136.696 226.774 136.783 226.484 136.783 226.156C136.783 225.815 136.696 225.515 136.52 225.256C136.348 224.995 136.094 224.789 135.759 224.64C135.428 224.491 135.027 224.416 134.556 224.416H133.696V223.163H134.556C134.934 223.163 135.265 223.095 135.55 222.96C135.839 222.824 136.064 222.635 136.227 222.393C136.389 222.147 136.47 221.861 136.47 221.533C136.47 221.218 136.399 220.944 136.256 220.712C136.117 220.477 135.918 220.293 135.66 220.161C135.405 220.028 135.103 219.962 134.755 219.962C134.424 219.962 134.114 220.023 133.825 220.146C133.54 220.265 133.308 220.437 133.129 220.663C132.95 220.885 132.854 221.152 132.841 221.463H131.354C131.371 220.913 131.533 220.429 131.842 220.011C132.153 219.594 132.564 219.267 133.075 219.032C133.585 218.797 134.152 218.679 134.775 218.679C135.428 218.679 135.991 218.807 136.465 219.062C136.942 219.314 137.31 219.65 137.569 220.071C137.831 220.492 137.96 220.953 137.957 221.453C137.96 222.023 137.801 222.507 137.479 222.905C137.161 223.303 136.737 223.569 136.207 223.705V223.785C136.883 223.888 137.406 224.156 137.778 224.59C138.152 225.024 138.338 225.563 138.335 226.206C138.338 226.766 138.182 227.268 137.867 227.712C137.556 228.156 137.13 228.506 136.589 228.761C136.049 229.013 135.431 229.139 134.735 229.139ZM140.912 229.094C140.641 229.094 140.407 228.998 140.211 228.806C140.016 228.611 139.918 228.375 139.918 228.1C139.918 227.828 140.016 227.596 140.211 227.404C140.407 227.209 140.641 227.111 140.912 227.111C141.184 227.111 141.418 227.209 141.613 227.404C141.809 227.596 141.907 227.828 141.907 228.1C141.907 228.282 141.86 228.45 141.767 228.602C141.678 228.751 141.559 228.871 141.409 228.96C141.26 229.05 141.095 229.094 140.912 229.094ZM147.075 229.139C146.451 229.139 145.891 229.02 145.394 228.781C144.9 228.539 144.506 228.208 144.211 227.787C143.916 227.366 143.759 226.885 143.739 226.345H145.23C145.267 226.783 145.46 227.142 145.812 227.424C146.163 227.706 146.584 227.847 147.075 227.847C147.466 227.847 147.812 227.757 148.114 227.578C148.419 227.396 148.657 227.146 148.83 226.827C149.005 226.509 149.093 226.146 149.093 225.739C149.093 225.324 149.004 224.955 148.825 224.63C148.646 224.305 148.399 224.05 148.084 223.864C147.772 223.679 147.414 223.584 147.01 223.581C146.702 223.581 146.392 223.634 146.08 223.74C145.769 223.846 145.517 223.985 145.325 224.158L143.918 223.949L144.489 218.818H150.087V220.136H145.767L145.444 222.984H145.504C145.702 222.792 145.966 222.631 146.294 222.502C146.625 222.373 146.98 222.308 147.358 222.308C147.978 222.308 148.53 222.456 149.013 222.751C149.501 223.046 149.884 223.448 150.162 223.959C150.444 224.466 150.583 225.049 150.58 225.709C150.583 226.368 150.434 226.957 150.132 227.474C149.834 227.991 149.42 228.398 148.889 228.697C148.362 228.992 147.757 229.139 147.075 229.139ZM155.781 218.679C156.235 218.682 156.683 218.765 157.123 218.928C157.564 219.09 157.962 219.355 158.317 219.723C158.675 220.091 158.96 220.588 159.172 221.214C159.387 221.838 159.497 222.613 159.5 223.541C159.5 224.433 159.41 225.227 159.231 225.923C159.052 226.615 158.796 227.2 158.461 227.678C158.129 228.155 157.727 228.518 157.253 228.766C156.779 229.015 156.245 229.139 155.652 229.139C155.045 229.139 154.507 229.02 154.036 228.781C153.565 228.543 153.183 228.213 152.888 227.792C152.593 227.368 152.409 226.88 152.336 226.33H153.852C153.952 226.768 154.154 227.122 154.459 227.394C154.767 227.663 155.165 227.797 155.652 227.797C156.398 227.797 156.979 227.472 157.397 226.822C157.814 226.17 158.025 225.258 158.028 224.088H157.949C157.776 224.373 157.561 224.618 157.302 224.824C157.047 225.029 156.76 225.188 156.442 225.301C156.124 225.414 155.784 225.47 155.423 225.47C154.836 225.47 154.303 225.326 153.822 225.038C153.342 224.749 152.959 224.353 152.674 223.849C152.389 223.346 152.246 222.771 152.246 222.124C152.246 221.481 152.392 220.898 152.684 220.374C152.979 219.851 153.39 219.436 153.917 219.131C154.447 218.823 155.068 218.672 155.781 218.679ZM155.786 219.972C155.398 219.972 155.049 220.068 154.737 220.26C154.429 220.449 154.185 220.706 154.006 221.031C153.827 221.352 153.738 221.71 153.738 222.104C153.738 222.499 153.824 222.857 153.996 223.178C154.172 223.496 154.411 223.75 154.712 223.939C155.017 224.125 155.365 224.217 155.756 224.217C156.048 224.217 156.32 224.161 156.572 224.048C156.823 223.936 157.044 223.78 157.233 223.581C157.422 223.379 157.569 223.15 157.675 222.895C157.781 222.64 157.834 222.371 157.834 222.089C157.834 221.715 157.745 221.367 157.566 221.045C157.39 220.724 157.148 220.465 156.84 220.27C156.532 220.071 156.18 219.972 155.786 219.972ZM166.61 227.091V226.554C166.61 226.17 166.69 225.818 166.849 225.5C167.011 225.179 167.247 224.922 167.555 224.729C167.867 224.534 168.243 224.436 168.684 224.436C169.134 224.436 169.512 224.532 169.817 224.724C170.122 224.917 170.352 225.174 170.508 225.495C170.667 225.817 170.747 226.17 170.747 226.554V227.091C170.747 227.475 170.667 227.828 170.508 228.15C170.349 228.468 170.115 228.725 169.807 228.92C169.502 229.113 169.128 229.209 168.684 229.209C168.236 229.209 167.858 229.113 167.55 228.92C167.242 228.725 167.008 228.468 166.849 228.15C166.69 227.828 166.61 227.475 166.61 227.091ZM167.769 226.554V227.091C167.769 227.376 167.837 227.634 167.973 227.866C168.109 228.098 168.346 228.214 168.684 228.214C169.018 228.214 169.252 228.098 169.385 227.866C169.517 227.634 169.583 227.376 169.583 227.091V226.554C169.583 226.269 169.519 226.01 169.39 225.778C169.264 225.546 169.028 225.43 168.684 225.43C168.352 225.43 168.117 225.546 167.978 225.778C167.838 226.01 167.769 226.269 167.769 226.554ZM161.49 221.264V220.727C161.49 220.343 161.569 219.99 161.728 219.668C161.891 219.347 162.126 219.09 162.434 218.898C162.746 218.705 163.122 218.609 163.563 218.609C164.014 218.609 164.391 218.705 164.696 218.898C165.001 219.09 165.232 219.347 165.387 219.668C165.543 219.99 165.621 220.343 165.621 220.727V221.264C165.621 221.649 165.542 222.002 165.382 222.323C165.227 222.641 164.995 222.898 164.686 223.094C164.382 223.286 164.007 223.382 163.563 223.382C163.112 223.382 162.733 223.286 162.424 223.094C162.119 222.898 161.887 222.641 161.728 222.323C161.569 222.002 161.49 221.649 161.49 221.264ZM162.653 220.727V221.264C162.653 221.549 162.719 221.808 162.852 222.04C162.988 222.272 163.225 222.388 163.563 222.388C163.894 222.388 164.126 222.272 164.259 222.04C164.395 221.808 164.463 221.549 164.463 221.264V220.727C164.463 220.442 164.398 220.184 164.269 219.952C164.14 219.72 163.904 219.604 163.563 219.604C163.231 219.604 162.996 219.72 162.857 219.952C162.721 220.184 162.653 220.442 162.653 220.727ZM161.962 229L168.962 218.818H170.15L163.15 229H161.962Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3105_3807",
    x: 62,
    y: 152,
    width: 20.4287,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3807"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3105_3807",
    x: 85.4287,
    y: 140,
    width: 20.4287,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3807"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_3105_3807",
    x: 108.857,
    y: 121,
    width: 20.4287,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3807"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_3105_3807",
    x: 132.286,
    y: 95,
    width: 20.4287,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3807"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_3105_3807",
    x: 155.714,
    y: 140,
    width: 20.4287,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3807"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_3105_3807",
    x: 179.143,
    y: 152,
    width: 20.4287,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3807"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_3105_3807",
    x: 202.571,
    y: 152,
    width: 20.4287,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0 0.425732 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3807"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_3105_3807",
    x: 84,
    y: 206,
    width: 116,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 32
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3105_3807"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3105_3807",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_3105_3807",
    x: 104,
    y: 210,
    width: 76,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_3105_3807"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.640658 0 0 0 0 0.640658 0 0 0 0 0.640658 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3105_3807"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3105_3807",
    x1: 132,
    y1: 189,
    x2: 152,
    y2: 189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3105_3807",
    x1: 132,
    y1: 88,
    x2: 152,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3105_3807",
    x1: 71.7143,
    y1: 152,
    x2: 71.7143,
    y2: 184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3105_3807",
    x1: 95.143,
    y1: 140,
    x2: 95.143,
    y2: 184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3105_3807",
    x1: 94,
    y1: 95.5,
    x2: 131.5,
    y2: 170.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3105_3807",
    x1: 117.429,
    y1: 58.9762,
    x2: 179.839,
    y2: 147.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3105_3807",
    x1: 165.429,
    y1: 140,
    x2: 165.429,
    y2: 184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3105_3807",
    x1: 188.857,
    y1: 152,
    x2: 188.857,
    y2: 184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3105_3807",
    x1: 212.286,
    y1: 152,
    x2: 212.286,
    y2: 184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202025"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3105_3807",
    x1: 142,
    y1: 0,
    x2: 142,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333338",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3105_3807",
    x1: 142,
    y1: 70,
    x2: 142,
    y2: -0.00000105926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3105_3807",
    x1: 142,
    y1: 320,
    x2: 142,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333338",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3105_3807",
    x1: 142,
    y1: 250,
    x2: 142,
    y2: 320,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3105_3807",
    x1: 132.5,
    y1: 49,
    x2: 132.5,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3105_3807",
    x1: 152.5,
    y1: 49,
    x2: 152.5,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3105_3807",
    x1: 132.5,
    y1: 271,
    x2: 132.5,
    y2: 190,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3105_3807",
    x1: 152.5,
    y1: 271,
    x2: 152.5,
    y2: 190,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3105_3807",
    x1: 264.5,
    y1: 0,
    x2: 264.5,
    y2: 320,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3105_3807",
    x1: 283.5,
    y1: 112,
    x2: 283.5,
    y2: 208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3105_3807",
    x1: 1.5,
    y1: 112,
    x2: 1.5,
    y2: 208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3105_3807",
    x1: 20.5,
    y1: 0,
    x2: 20.5,
    y2: 320,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3105_3807",
    x1: 264,
    y1: 95.5,
    x2: 20,
    y2: 95.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3105_3807",
    x1: 253,
    y1: 95,
    x2: 264,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3105_3807",
    x1: 0,
    y1: 1,
    x2: 11,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3105_3807",
    x1: 142.5,
    y1: 39,
    x2: 142.5,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3105_3807",
    x1: 142.5,
    y1: 281,
    x2: 142.5,
    y2: 271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3105_3807",
    x1: 102,
    y1: 224,
    x2: 182,
    y2: 224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C298"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#62C687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678511,
    stopColor: "#A0CA7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6CC70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3105_3807",
    x1: 142,
    y1: 210,
    x2: 142,
    y2: 238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A2A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#202025"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.b1b2cf42a3052f1b33128739e583a3d8.svg";
export { ForwardRef as ReactComponent };